import { ErrorMessage, executeRequest, Request, Response } from '@jfs/network'
import { convertBoolValue, getBillId } from '../util/billPaymentUtil'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

export interface AddBillInput {
  billerMasterId: number
  authenticators: Array<string>
}

const responseParser = (data: Response, values: AddBillInput) => {
  const resposne = data.data
  const responseData = data.data.responseObj[0]
  const billId = getBillId(values.billerMasterId, values.authenticators)

  if (resposne.errorCode !== '000') {
    const msg = {
      message: resposne.errorMessage,
    }
    throw msg
  }

  const registerBillerResponse = {
    id: billId,
    operatorId: values.billerMasterId,
    authenticators: responseData?.authenticators ?? [],
    labelOfAuthenticators: responseData?.labelOfAuthenticators ?? [],
    customerBillerAccountId: responseData?.customerBillerAccountId ?? null,
    shortName: responseData?.shortName ?? null,
    alertMessage: resposne?.errorMessage,
    existingBillerFlag: convertBoolValue(responseData?.existingBillerFlag) ?? null,
    type: 'no_bill',
  }

  return registerBillerResponse
}

const body = (values: any) => {
  return {
    product: {
      id: values?.billerMasterId,
      attribute: {
        authenticatorList: values?.authenticators,
      },
    },
    beneficiary: {
      nickName: values?.shortName,
    },
    standingInstruction: {
      siStatus: values?.siStatus,
      siMaxLimit: values?.siMaxLimit,
      payDaysBefore: values?.payDaysBefore,
    },
    domain: {
      id: 'PayMyBill',
      name: 'PayMyBill',
      transactionType: 'BUY',
      description: 'This is for the buy case',
    },
    initiatingEntity: {
      entityId: 3131,
      channelId: '1234',
    },
  }
}

export const registerBillerAPI = (tokens: any, userAccessToken: any, values: AddBillInput) => {
  const config = sitConfig(tokens)
  //config.baseUrl = Config.REACT_APP_JFS_BASE_URL
  const request: Request<{}> = {
    apiPath: APIEndPoints.registerBiller,
    method: 'POST',
    config: config,
    body: body(values),
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken,
    },
  }

  return executeRequest(request)
    .then((data: any) => {
      if (data?.data?.responseStatus?.code === '000') {
        return responseParser(data, values)
      }
      if (data?.data?.status === 'F' || data?.data?.error?.code) {
        const msg = {
          errorCode: data?.data?.error?.code,
          errorMessage: data?.data?.errorMessage
            ? data?.data?.errorMessage
            : data?.data?.error?.message ?? ErrorMessage.ERROR_PROCESSING_REQUEST,
        }
        throw msg
      }
      return null
    })
    .catch((error) => {
      throw error
    })
}
